import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as userActions } from '../../store/user';
import { LoginComponent } from 'components/index.js';
import DOMPurify from 'dompurify';
const { login, initializeLogin } = userActions;

const schema = {
  username: {
    presence: { allowEmpty: false, message: 'is required' },
    email: false,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: true,
    format: { pattern: '[^]+', message: 'is required' }
  }
};

const SignIn = () => {
  const [isOpen, setIsOpen] = useState(true);
  const error = useSelector(store => store.user.error);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initializeLogin());
  }, []);

  const getInputFields = () => [
    { name: 'username', label: "USER ID", type: 'text' },
    { name: 'password', label: "PASSWORD", type: 'password' }
  ];

  const getButtonGroup = () => [
    { title: 'Login', action: (event, values) => handleSignIn(event, values), isSubmit: true }
  ];

  const handleSignIn = (event, values, forceLogin) => {
    let username = DOMPurify.sanitize(values.username);
    let password = DOMPurify.sanitize(values.password);
    event.preventDefault();
    dispatch(
      login(username, password, {
        clearSessionData: true,
        forceLogin
      })
    );
  };

  const inputModalAttrributes = {
    concurrentMessage: (username) => {
      return (
        <>
          <p style={{ fontSize: '15px' }}>
            You currently have an active session with this user name{' '}
            <span style={{ fontWeight: 'bold' }}>{username}</span>.{' '}
            <br /> Select <span style={{ fontWeight: 'bold' }}>Continue</span> to
            terminate the other session and proceed with this session, or click{' '}
            <span style={{ fontWeight: 'bold' }}>Cancel</span> to terminate this
            login.</p>
        </>);
    },

    inputModaltitle: "Active Session",

    getInputButtonsGroup: [
      {
        name: 'Cancel',
        action: () => { setIsOpen(false) }
      },
      {
        name: 'Continue',
        action: (event, values) => { handleSignIn(event, values, true) }
      },
    ],

    modalShowCondition: error?.message?.instructions === 'Session already exists'
      && error?.raw?.concurrentCode === 1003
      && error?.raw?.concurrentStatus === 401
  }
  return (
    <LoginComponent
      title={'Login'}
      subTitle={'Login with tenant domain'}
      inputFields={getInputFields()}
      buttonGroup={getButtonGroup()}
      isLoginPage={true}
      schema={schema}
      inputModalAttrributes={inputModalAttrributes}
      setIsOpen={setIsOpen}
      isOpen={isOpen}
    />
  );
};

export default SignIn;